export function newsletterExtras(form, props) {
  const html = document.querySelector("html");

  // instantiate template:
  const template = document.querySelector("template#newsletter-sticky-bar");
  const stickyBar = document.importNode(template.content.children[0], true);
  html.appendChild(stickyBar);

  const findByTextContent = (selector, textContent) => {
    for (const element of form.querySelectorAll(selector)) {
      if (element.textContent === textContent) {
        return element;
      }
    }
  };

  const findAddSectionButton = () =>
    findByTextContent("button", "Add a section");

  const findSubmitButton = () => form.querySelector(".js-submit-button");

  // attach sticky bar events
  const saveChanges = stickyBar.querySelector(".js-save-changes");
  saveChanges.addEventListener("click", () => {
    const button = findSubmitButton();
    if (button) {
      button.click();
    }
  });

  const addASection = stickyBar.querySelector(".js-add-section");
  addASection.addEventListener("click", () => {
    const button = findAddSectionButton();
    if (button) {
      button.click();
      document.scrollingElement.scroll(
        0,
        document.scrollingElement.scrollHeight
      );
    }
  });

  return {
    destroy() {
      html.removeChild(stickyBar);
    }
  };
}
